module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/DailyPrecipitation0/Kanagawa_DailyPrecipitation0_MRI_RCP85_End.png";